import tablePlugin from './table';
import headerCellPlugin from './headerCell';
import bodyCellPlugin from './bodyCell';
import treePlugin from './tree';
import treeSelectPlugin from './treeSelect';

export {
  tablePlugin,
  headerCellPlugin,
  bodyCellPlugin,
  treePlugin,
  treeSelectPlugin
}

export default [bodyCellPlugin, tablePlugin, headerCellPlugin, treePlugin, treeSelectPlugin];